import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"arrow-down\">\n    <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->\n    <path d=\"M32 11l-2-2-14 14-14-14-2 2 16 16 16-16z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol